import { render, staticRenderFns } from "./argolla.vue?vue&type=template&id=3b949c46&scoped=true"
import script from "./argolla.vue?vue&type=script&lang=js"
export * from "./argolla.vue?vue&type=script&lang=js"
import style0 from "./argolla.vue?vue&type=style&index=0&id=3b949c46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b949c46",
  null
  
)

export default component.exports